import { render, staticRenderFns } from "./FormTipoFoto.vue?vue&type=template&id=1cd522af"
import script from "./FormTipoFoto.vue?vue&type=script&lang=js"
export * from "./FormTipoFoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports